// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__5rOqw","left":"StickyBox_left__2BgPT","right":"StickyBox_right__33-x2"};